import React from 'react'
import FactsData from './../../factsData.json'
import Tag from "../Tag"

import './style.scss'

class ContextMenu extends React.Component {
  render() {
    const tags = FactsData.tags.sort(function (a, b) {
      return a.order - b.order
    })

    return (
      <>
        <div className="context-menu-wrapper" onClick={() => this.props.closeContextMenu()}/>
        <div className="context-menu" onClick={() => this.props.closeContextMenu()}>
          <Tag
            {...this.props}
            className={this.props.currentTag === 'all' ? 'selected' : ''}
            tagId="all"
            title="все темы"
          />
          {
            Object.values(tags).map((data, index) =>
              <Tag
                {...this.props}
                className={this.props.currentTag === data.id ? 'selected' : ''}
                key={index}
                tagId={data.id}
                title={data.name}
              />
            )
          }
          <Tag
            {...this.props}
            className={this.props.currentTag === 'quiz' ? 'selected' : ''}
            tagId="quiz"
            title="тесты"
          />
        </div>
      </>
    )
  }
}

export default ContextMenu
